import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./header.css";

const Header = () => {
  const [theme, setTheme] = useState("light");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { userProfile } = useAuth();

  const location = useLocation();

  // Initialize theme from localStorage or default to light
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  // Toggle theme function
  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-container">
          {/* Logo */}
          <Link to="/" className="nav-logo">
            Anjali D Music
          </Link>

          {/* Right side: Navigation + Theme Toggle */}
          <div className="nav-right">
            {/* Desktop Navigation */}
            <ul className="nav-menu">
              <li className="nav-item">
                <Link
                  to="/"
                  className={`nav-link ${
                    location.pathname === "/" ? "active" : ""
                  }`}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/bio"
                  className={`nav-link ${
                    location.pathname === "/bio" ? "active" : ""
                  }`}
                >
                  Bio
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/music"
                  className={`nav-link ${
                    location.pathname === "/music" ? "active" : ""
                  }`}
                >
                  Music
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/contact"
                  className={`nav-link ${
                    location.pathname === "/contact" ? "active" : ""
                  }`}
                >
                  Contact
                </Link>
              </li>
              {userProfile && userProfile?.roles?.includes("admin") && (
                <li className="nav-item">
                  <Link
                    to="/daswani-dashboard"
                    className={`nav-link ${
                      location.pathname === "/daswani-dashboard" ? "active" : ""
                    }`}
                  >
                    Dashboard
                  </Link>
                </li>
              )}
            </ul>

            {/* Theme Toggle & Mobile Menu Button */}
            <div className="nav-actions">
              <button
                onClick={toggleTheme}
                className="theme-toggle"
                aria-label="Toggle dark mode"
              >
                {theme === "light" ? "🌙" : "☀️"}
              </button>

              <button
                className={`mobile-menu-btn ${isMenuOpen ? "active" : ""}`}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle mobile menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMenuOpen ? "active" : ""}`}>
          <ul className="mobile-nav-menu">
            <li>
              <Link
                to="/"
                className={`mobile-nav-link ${
                  location.pathname === "/" ? "active" : ""
                }`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/bio"
                className={`mobile-nav-link ${
                  location.pathname === "/bio" ? "active" : ""
                }`}
              >
                Bio
              </Link>
            </li>
            <li>
              <Link
                to="/music"
                className={`mobile-nav-link ${
                  location.pathname === "/music" ? "active" : ""
                }`}
              >
                Music
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`mobile-nav-link ${
                  location.pathname === "/contact" ? "active" : ""
                }`}
              >
                Contact
              </Link>
            </li>
            {userProfile && userProfile?.roles?.includes("admin") && (
              <li>
                <Link
                  to="/daswani-dashboard"
                  className={`mobile-nav-link ${
                    location.pathname === "/daswani-dashboard" ? "active" : ""
                  }`}
                >
                  Dashboard
                </Link>
              </li>
            )}
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
